<template>
    <div class="select-category-component">
        <a-select :loading="loading"
                  :disabled="disabled"
                  :placeholder="placeholder"
                  :value="value"
                  style="width: 100%;"
                  @change="onChange">
            <a-select-option v-for="(category, key) in categories" :key="key" :value="category.id">
                {{ category.name }}
            </a-select-option>
        </a-select>
    </div>
</template>

<script>
import categoryApi from '~/api/category'

export default {
  name: 'SelectCategoryComponent',
  props: {
    value: {
      type: [Array, Number, String],
      default: null,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Selecteer...'
    },
  },
  data () {
    return {
      categories: [],
      loading: true,
      setValue: this.value,
    }
  },
  mounted () {
    this.initCategories()
  },
  methods: {
    initCategories () {
      categoryApi.getCategories().then(response => {
        this.categories = response.data
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt om de categoriën te laden',
        })
      }).finally(() => {
        this.loading = false
      })
    },
    onChange (category) {
      this.setValue = category
      this.$emit('change', category)
      this.$emit('input', category)
    }
  }
}
</script>
